/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IngredientDeleteModalMutationVariables = {|
  id: string
|};
export type IngredientDeleteModalMutationResponse = {|
  +ingredientDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type IngredientDeleteModalMutation = {|
  variables: IngredientDeleteModalMutationVariables,
  response: IngredientDeleteModalMutationResponse,
|};
*/


/*
mutation IngredientDeleteModalMutation(
  $id: ID!
) {
  ingredientDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "IngredientDeletePayload",
    "kind": "LinkedField",
    "name": "ingredientDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IngredientDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IngredientDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "IngredientDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation IngredientDeleteModalMutation(\n  $id: ID!\n) {\n  ingredientDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '39217e2f693d5f771f26e2f46be75af3';

module.exports = node;
